/**
 * nest 構造の reactive な プロパティを破壊しないように値を bind する
 *
 * @param assignSource {Object} bind される state のプロパティ
 * @param bindData {Object} bind するデータ
 *
 * @returns {Object} bind 後のオブジェクト
 */
export default function bindState(assignSource: anyData, bindData: anyData) {
  Object.keys(assignSource).forEach(key => {
    const _key = key as keyof anyData
    if (bindData && bindData[_key] != null) {
      if (Array.isArray(assignSource[_key])) {
        assignSource[_key] = bindData[_key]
      } else if (
        assignSource[_key] !== null &&
        typeof assignSource[_key] === 'object' &&
        Object.keys(assignSource[_key]).length /* 非空オブジェクト */
      ) {
        // 対象がオブジェクトの場合は再帰処理
        bindState(assignSource[_key], bindData[_key])
      } else if (bindData) {
        // bindData が存在する場合のみ props へセットする
        assignSource[_key] = bindData[_key]
      }
    }
  })

  return assignSource
}
